import React, { useState, useRef, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Badge from 'react-bootstrap/Badge';
import axios from 'axios';
import {useNavigate} from "react-router-dom";
import '../App.css';
import {
   
    Link
  } from "react-router-dom";

const Planer = () => {
    const navigate = useNavigate();
  const [modalShow, setModalShow] = useState(true);
  const [ModalTable, setModalTable] = useState(false);
  const [inputFocused, setInputFocused] = useState(false);
  const [suche, setSuche] = useState(false);
  const [loading, setLoading] = useState(false);
  const [daten, setDaten] = useState([]);
  const [TableDaten, setTableDaten] = useState([]);
  const [searchfield, setSearchfield] = useState('');
  const [vertrag, setvertrag] = useState('');
  const [filter, setfilter] = useState(true);
  const [artikelnummer, setArtikelnummer] = useState('');
  const inputRef = useRef(null);
  const [gesamtStatus, setGesamtStatus] = useState(0);
  const [aktdoc, setaktdoc] = useState('');
  const [nurAbgeschlossen, setNurAbgeschlossen] = useState(false);


  useEffect(() => {  
    
    if (localStorage.getItem("loginData") == null) {
            
      navigate("/dhworld/login");
      
    } 
}, []);

useEffect(() => {
  search();
}, [nurAbgeschlossen]);

  const focusInput = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  
  const filteraendern = async () => {
    setfilter(prev => {
      const newFilter = !prev;
      search(newFilter);
      return newFilter;
    });
  }

  const search = async (currentFilter = filter) => {
    if (searchfield.trim() === '' && artikelnummer.trim() === '') return;
    setLoading(true);
    setModalShow(false);
    setSuche(true);
    try {
      const res = await axios.get('https://dhworld.dietenmeier-harsch.de/searchMaterial.php', {
        withCredentials: true,
        params: { 
          searchfield, 
          filter: currentFilter ? '1' : '0',
          artikelnummer,
          abgeschlossen: nurAbgeschlossen ? '1' : '0' // 👈 NEU
        }
      });
      
      setDaten(res.data.daten);
      //setGesamtStatus(res.data.gesamtstatus);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
};


  const click = async (bild, dokumentnnummer, lagerort, auftr) => {
    setvertrag(auftr);
    setaktdoc(dokumentnnummer);
 
  
    try {
      const res = await axios.get('https://dhworld.dietenmeier-harsch.de/searchMaterialDetails.php', {
        withCredentials: true,
        params: { dokumentnnummer }
      });
  
      // füge bild & lagerort zu jedem Element hinzu
      const updatedData = res.data.daten.map((item) => ({
        ...item,
        bild: bild,
        lagerort: lagerort,
        doc: dokumentnnummer
      }));
  
      setTableDaten(updatedData);
      setGesamtStatus(res.data.gesamtstatus);

      setModalTable(true);
    } catch (err) {
      if (err.response?.status === 500) {
        //alert('There was a problem with the server');
      } else {
        //alert(err.response?.data?.msg || 'Ein Fehler ist aufgetreten');
      }
    }
  };


  const clickstate = async (IntDocNr, ArtPos_ArtikelNummer, index, docc) => {
   
    

    const updatedTableDaten = [...TableDaten]; // Array kopieren
    const aktuellerStatus = updatedTableDaten[index].genommen;
    const neuerStatus = aktuellerStatus === 1 ? 0 : 1
    updatedTableDaten[index] = {
      ...updatedTableDaten[index], // Objekt kopieren
      genommen: updatedTableDaten[index].genommen === 1 ? 0 : 1
    };
    setTableDaten(updatedTableDaten);

    try {
      const res = await axios.get('https://dhworld.dietenmeier-harsch.de/updateMaterialDetails.php', {
        withCredentials: true,
        params: { IntDocNr, ArtPos_ArtikelNummer, neuerStatus, docc }
      });
  
      setGesamtStatus(res.data.gesamtstatus);
      search();
     
    } catch (err) {
      if (err.response?.status === 500) {
        //alert('There was a problem with the server');
      } else {
        //alert(err.response?.data?.msg || 'Ein Fehler ist aufgetreten');
      }
    }
  };

  const allback = async (nr) => {
   
    const updatedTableDaten = TableDaten.map(item => ({
      ...item,
      genommen: 0
    }));
    
    setTableDaten(updatedTableDaten);
    
    try {
      const res = await axios.get('https://dhworld.dietenmeier-harsch.de/allback.php', {
        withCredentials: true,
        params: { nr }
      });
  
      setGesamtStatus(res.data.gesamtstatus);
      search();
     
    } catch (err) {
      if (err.response?.status === 500) {
        //alert('There was a problem with the server');
      } else {
        //alert(err.response?.data?.msg || 'Ein Fehler ist aufgetreten');
      }
    }
  };

  const alltake = async (nr) => {
   
    const updatedTableDaten = TableDaten.map(item => ({
      ...item,
      genommen: 1
    }));
    
    setTableDaten(updatedTableDaten);
    
    try {
      const res = await axios.get('https://dhworld.dietenmeier-harsch.de/alltake.php', {
        withCredentials: true,
        params: { nr }
      });
  
      setGesamtStatus(res.data.gesamtstatus);
      search();
     
    } catch (err) {
      if (err.response?.status === 500) {
        //alert('There was a problem with the server');
      } else {
        //alert(err.response?.data?.msg || 'Ein Fehler ist aufgetreten');
      }
    }
  };

  const handleClear = () => {
    setSearchfield('');
    setArtikelnummer('');
    setDaten([]);
    setSuche(false);
};

  return (
    <div
      style={{
        backgroundColor: '#eceff2',
        minHeight: '100vh',
      }}
      className="container-fluid"
    >
      <div className="row pt-4">
        <div className='col-12'>
        <Link
            to="/insight">
        <i style={{fontSize: '25px'}} class="bi bi-arrow-return-left"></i> <br></br><br></br>
        </Link>

          {/* Lupe mit Suchtext und X (nur wenn gesucht und Suchfeld nicht leer) */}
          {suche && searchfield.trim() !== '' && (
            <Row style={{background: '#fff', border: '1px solid #e6e8ed', boxshadow: '0 2px 4px #00000012', height: '5.2rem'}}>
              <Col xs={1}>
                <i  className="bi bi-search" style={{ cursor: 'pointer', color: '#1245fb', fontSize: '20px' }} onClick={() => setModalShow(true)}></i>
              </Col>
              <Col style={{}} xs={3}>
                Suche: {searchfield}
              </Col>
              <Col xs={1}>
                <i className="bi bi-x-lg" style={{ cursor: 'pointer', color: '#1245fb', fontSize: '20px' }} onClick={handleClear}></i>
              </Col>
            </Row>
          )}

          {/* Loading oder Ergebnisse / Info */}
          {loading ? (
            <Row>
              <Col xs={12} className="text-center">
                <Spinner animation="border" variant="primary" />
              </Col>
            </Row>
          ) : !suche || searchfield.trim() === '' ? (
            <div>
              <h3 style={{ fontWeight: 'bold' }}>Es wurde noch kein Suchbegriff eingegeben.</h3>
              <p>Klicken Sie auf die Lupe, um zu suchen.</p>
              <i className="bi bi-search" style={{ fontSize: '1.5rem', cursor: 'pointer' }} onClick={() => setModalShow(true)}></i>
            </div>
          ) : (
            <div>

                <br></br>

                <Row className="g-4">

                <Col xs={12}>
      <Form.Check 
        type="switch"
        label={filter ? 'Offene Aufträge' : 'Alle Aufträge'}
        className="farbe"
        checked={filter}
        onChange={() => {
          setfilter(prev => {
            const newFilter = !prev;
            search(newFilter);
            return newFilter;
          });
        }}
      />

      <br /><br />

      <Form.Check 
  type="checkbox"
  label="Nur abgeschlossene Aufträge anzeigen"
  checked={nurAbgeschlossen}
  onChange={(e) => setNurAbgeschlossen(e.target.checked)}

/>
<br></br>

      <Form.Group controlId="artikelnummerFilter">
  <Form.Control
    style={{ marginTop: '10px' }}
    type="text"
    placeholder="Artikelbezeichnung eingeben (optional)"
    value={artikelnummer}
    onChange={(e) => setArtikelnummer(e.target.value)}
  />
</Form.Group>
<div className="mt-2">
  <i 
    className="bi bi-search"
    style={{ cursor: 'pointer', color: '#1245fb', fontSize: '20px' }}
    title="Suche mit Artikelnummer"
    onClick={() => search()}
  ></i>
</div>
<br /><br />
    </Col>

{daten && daten.length > 0 ? (
  <>
 

    {daten.map((v, index) => (
      <Col 
        onClick={() => click(v.Bild, v.Dokumentnummer, v.Lagerort, searchfield)} 
        style={{ cursor: 'pointer' }} 
        key={index} 
        md={4}
      >
        <div style={{ 
          background: '#fff', 
          padding: '1rem', 
          borderRadius: '8px', 
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)', 
          height: '100%', 
          position: 'relative' 
        }}>
          {v.Bild && (
            <i
              className="bi bi-image"
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                fontSize: '1.2rem',
                color: '#007bff',
                cursor: 'pointer'
              }}
              title="Bild öffnen"
              onClick={() => window.open(v.Bild, '_blank')}
            />
          )}

{v.gesamtstatus == 1 ? (
            <Row>
              <Col xs={3}>
              <Badge bg="danger">Alle Artikel im Beleg wurden bereits mitgenommen</Badge> <br></br>  <br></br>
              </Col>
            </Row>
           
          ) : (
            <Row>
              <Col xs={3}>
            <Badge bg="success">Es existieren noch nicht mitgenommene Artikel im Beleg</Badge> <br></br> <br></br>
            </Col>
            </Row>
          )}

          <p><strong>Auftragsnummer:</strong> {searchfield}</p>
          <p><strong>Belegart:</strong> {v.Belegart}</p>
          <p><strong>Datum Beleg:</strong> {v.DatumBeleg}</p>
          <p><strong>Dokumentennummer:</strong> {v.Dokumentnummer}</p>
          <p><strong>Lagerort:</strong> {v.Lagerort}</p>
        </div>
      </Col>
    ))}
  </>
) : (
  <Col xs={12}>
    <div style={{ background: '#fff', padding: '1rem', borderRadius: '8px', textAlign: 'center' }}>
      Keine Daten gefunden
    </div>
  </Col>
)}

</Row>
             
            </div>
          )}
        </div>
      </div>

      {/* Suchmodal */}
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={modalShow}
        onHide={() => setModalShow(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Nach exaktem Kleinauftrag suchen
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ paddingBottom: '60px' }}>
          <div
            style={{
              backgroundColor: '#eceff2',
              padding: '20px',
              borderRadius: '8px',
              cursor: 'text',
              borderBottom: inputFocused ? '3px solid #66bfff' : '3px solid #ccc',
              transition: 'border-color 0.3s ease',
            }}
            onClick={focusInput}
          >
            <Form onSubmit={(e) => {
              e.preventDefault();
              search();
            }}>
              <Form.Group controlId="exampleForm.ControlInput1" style={{ marginBottom: '0' }}>
                <Form.Control
                  ref={inputRef}
                  onFocus={() => setInputFocused(true)}
                  onBlur={() => setInputFocused(false)}
                  style={{
                    backgroundColor: 'transparent',
                    fontSize: '1.4rem',
                    border: 'none',
                    boxShadow: 'none',
                    outline: 'none',
                  }}
                  type="text"
                  placeholder="Suchbegriff eingeben"
                  value={searchfield}
                  onChange={(e) => setSearchfield(e.target.value)}
                />
              </Form.Group>
            </Form>
          </div>
        </Modal.Body>
      </Modal>




      <Modal size="lg" show={ModalTable} onHide={() => setModalTable(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Detailanzeige zu Kleinauftrag {vertrag}</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Row>
      {TableDaten && TableDaten.length > 0 ? (
        <>
          {gesamtStatus == 1 ? (
            <Row>
              <Col xs={3}>
              <Badge    onClick={() =>
                            allback(
                            
                              aktdoc
                            )
                          } bg="danger">Alle Artikel zurückgeben</Badge> <br></br>  <br></br>
              </Col>
            </Row>
           
          ) : (
            <Row>
              <Col xs={3}>
            <Badge onClick={() =>
                            alltake(
                            
                              aktdoc
                            )
                          } bg="success">Alle Artikel mitnehmen</Badge> <br></br> <br></br>
            </Col>
            </Row>
          )}

          <Col xs={12}>
            <Table striped responsive bordered hover>
              <thead>
                <tr>
                  <th>Artikelnummer</th>
                  <th>Artikelbezeichnung</th>
                  <th>Lagerort</th>
                  <th>Status</th>
                  <th>Dokumentennummer</th>
                  <th>Bild</th>
                </tr>
              </thead>
              <tbody>
                {TableDaten.map((v, index) => (
                  <tr key={index}>
                    <td>{v.ArtPos_ArtikelNummer}</td>
                    <td>{v.ArtPos_Langtext}</td>
                    <td>{v.lagerort}</td>
                    <td>
                      {v.genommen === 1 ? (
                        <Badge
                          bg="danger"
                          onClick={() =>
                            clickstate(
                              v.IntDocNr,
                              v.ArtPos_ArtikelNummer,
                              index,
                              v.doc
                            )
                          }
                        >
                          Artikel wurde mitgenommen, klicken für Rückgabe
                        </Badge>
                      ) : (
                        <Badge
                          bg="success"
                          onClick={() =>
                            clickstate(
                              v.IntDocNr,
                              v.ArtPos_ArtikelNummer,
                              index,
                              v.doc
                            )
                          }
                        >
                          Artikel entnehmen
                        </Badge>
                      )}
                    </td>
                    <td>{v.doc}</td>
                    <td>
                      {v.bild && (
                        <i
                          className="bi bi-image"
                          style={{
                            fontSize: '1.2rem',
                            color: '#007bff',
                            cursor: 'pointer',
                          }}
                          title="Bild öffnen"
                          onClick={() => window.open(v.bild, '_blank')}
                        />
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </>
      ) : (
        <Col className="text-center" xs={12}>
          <h3>Es sind keine weiteren Details verfügbar</h3>
        </Col>
      )}
    </Row>
  </Modal.Body>
</Modal>

    </div>
  );
};

export default Planer;
